export const INPUT_TAG_NAME = "input" as const;

export const INPUT_VARIANTS = ["default", "filled", "ghost"] as const;

export const INPUT_MASKS = ["duration", "license-plate"] as const;
